import { TilemapEditsManager } from "../../GameMap/TilemapEditsManager";
import type { WamFile } from "../../GameMap/WamFile";
import { Command } from "../Command";

export class MoveTileLayerCommand extends Command {
    protected wamFile: WamFile;

    constructor(
        wamFile: WamFile,
        protected readonly layerId: number,
        protected readonly newIndex: number,
        commandId?: string,
    ) {
        super(commandId);
        this.wamFile = wamFile;
    }

    public execute(): Promise<void> {
        const overlay = TilemapEditsManager.getOrCreateOverlay(this.wamFile.getWam());
        overlay.layerEdits.push({ action: "move", layerId: this.layerId, newIndex: this.newIndex });
        return Promise.resolve();
    }
}
